import { createFileRoute, useParams } from '@tanstack/react-router';
import { RumPageRendered } from '@/services/rum/use-page-rendered';
import DataIndexItemPage from '@/pages/workspaces/data-index/item/index.page';
import { DataIndexRoute } from '@/pages/workspaces/data-index/routing';
import { DataIndexItemResolver } from '@/pages/workspaces/data-index/data-index-item-resolver';
import { LastWorkspaceResolver } from './-route-layouts';

/**
 * One object or relationship attribute, whose name only means something under
 * its object type: `/data-index/object-attributes/3/tier`. The object type is
 * `itemId` here, because a route tree cannot give one position two names.
 */
function DataIndexNestedItemRouteComponent() {
  const { type, itemId, nestedItemId } = useParams({
    from: '/_authenticated/workspaces/$workspaceId/data-index/$type/$itemId/$nestedItemId',
  });

  return (
    <LastWorkspaceResolver>
      <DataIndexItemResolver segment={type} itemId={itemId} nestedItemId={nestedItemId}>
        {(address) => (
          <DataIndexRoute>
            <RumPageRendered>
              <DataIndexItemPage address={address} />
            </RumPageRendered>
          </DataIndexRoute>
        )}
      </DataIndexItemResolver>
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/data-index/$type/$itemId/$nestedItemId')({
  component: DataIndexNestedItemRouteComponent,
});
